module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-kaoawase-course-meal-760650dbceda4c8366d8299debb86181.jpg";